module.exports = __webpack_public_path__ + "static/media/logo_cn_invert_fr.2187353b.svg";